import { render, staticRenderFns } from "./AccountingPeriodsList.vue?vue&type=template&id=1bfec267&scoped=true"
import script from "./AccountingPeriodsList.vue?vue&type=script&lang=js"
export * from "./AccountingPeriodsList.vue?vue&type=script&lang=js"
import style0 from "./AccountingPeriodsList.vue?vue&type=style&index=0&id=1bfec267&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1bfec267",
  null
  
)

export default component.exports